import angular from 'angular'
import statisticsInvState from './statisticsInvState'
import statisticsOpenedInv from './statisticsOpenedInv'
import statisticsProduct from './statisticsProduct'
import statisticsTaxRate from './statisticsTaxRate'
import statisticsSalesRank from './statisticsSalesRank'

export default angular.module('app.statistics.outputStatistics', [statisticsInvState, statisticsOpenedInv, statisticsProduct, statisticsTaxRate, statisticsSalesRank])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.outputStatistics', {
            url: '/outputStatistics',
            template: '<div ui-view></div>',
            abstract: true,
            title: '销项统计',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/index.js